export const categories = [
  {
    id: "construction",
    name: "建筑白浆",
    icon: "ri-building-line",
    description: "建筑白浆是建筑行业中不可或缺的基础材料，广泛应用于墙面涂装、地面找平、防水密封及装饰装修等环节。优质建筑白浆具有粘结力强、抗裂性好、施工便捷等特点，能够显著提升建筑物的整体质量与使用寿命。",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20white%20construction%20paste%20material%20on%20wooden%20surface%20with%20trowel%2C%20professional%20studio%20lighting%2C%20warm%20neutral%20background%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20high%20detail%2C%20textured%20white%20substance&width=800&height=500&seq=baijiang-cat-const-01&orientation=landscape",
    features: [
      { label: "粘结强度", value: "≥1.5MPa" },
      { label: "施工温度", value: "5°C-35°C" },
      { label: "初凝时间", value: "≤3小时" },
      { label: "适用范围", value: "内外墙通用" },
    ],
    applications: ["墙面找平", "瓷砖粘贴", "防水层施工", "地面自流平", "装饰造型"],
  },
  {
    id: "paper",
    name: "造纸白浆",
    icon: "ri-file-paper-2-line",
    description: "造纸白浆是纸张制造过程中的关键中间体，由纸浆纤维、填料、助剂等经精细调配而成。高品质造纸白浆能够赋予纸张优良的白度、平滑度与印刷适性，是文化用纸、包装用纸及特种纸张的核心原料。",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20white%20paper%20pulp%20slurry%20in%20industrial%20vat%2C%20professional%20studio%20lighting%2C%20warm%20neutral%20background%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20high%20detail%2C%20organic%20texture&width=800&height=500&seq=baijiang-cat-paper-01&orientation=landscape",
    features: [
      { label: "白度", value: "≥90% ISO" },
      { label: "纤维长度", value: "0.5-3.0mm" },
      { label: "浓度范围", value: "3%-8%" },
      { label: "pH值", value: "6.5-8.5" },
    ],
    applications: ["文化用纸", "包装纸板", "特种纸张", "生活用纸", "工业滤纸"],
  },
  {
    id: "food",
    name: "食品级白浆",
    icon: "ri-restaurant-line",
    description: "食品级白浆是严格按照食品安全标准生产的专用白色浆料，广泛应用于食品加工中的增稠、稳定、乳化及口感改良。产品通过多项国际食品安全认证，确保在满足工艺需求的同时保障消费者的健康安全。",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20white%20food%20grade%20paste%20in%20ceramic%20bowl%2C%20professional%20studio%20lighting%2C%20warm%20neutral%20background%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20high%20detail%2C%20smooth%20creamy%20texture&width=800&height=500&seq=baijiang-cat-food-01&orientation=landscape",
    features: [
      { label: "安全标准", value: "GB 2760-2024" },
      { label: "微生物指标", value: "≤1000 CFU/g" },
      { label: "重金属含量", value: "符合国标" },
      { label: "保质期", value: "12个月" },
    ],
    applications: ["饮料增稠", "酱料填充", "烘焙改良", "乳制品稳定", "糖果涂层"],
  },
  {
    id: "industrial",
    name: "工业白浆",
    icon: "ri-settings-3-line",
    description: "工业白浆涵盖涂料、胶黏剂、密封材料等多个工业细分领域的白色浆状产品。其配方灵活多变，可根据具体工艺要求定制粘度、固含量及功能性，是现代工业生产中不可或缺的重要辅助材料。",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20white%20industrial%20paste%20in%20metal%20container%2C%20professional%20studio%20lighting%2C%20warm%20neutral%20background%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20high%20detail%2C%20smooth%20viscous%20substance&width=800&height=500&seq=baijiang-cat-ind-01&orientation=landscape",
    features: [
      { label: "固含量", value: "30%-85%" },
      { label: "粘度范围", value: "500-50000 mPa·s" },
      { label: "耐温范围", value: "-20°C-200°C" },
      { label: "定制服务", value: "支持配方定制" },
    ],
    applications: ["涂料生产", "胶黏剂制造", "密封材料", "模塑成型", "表面处理"],
  },
];

export const articles = [
  {
    id: "article-1",
    slug: "baijiang-yuanliao-xiangjie",
    title: "白浆原料组成详解：从天然矿物到合成材料",
    excerpt: "深入了解白浆的核心原料构成，包括天然矿物填料、高分子粘结剂、功能性添加剂等，剖析各组分对白浆性能的影响机制。",
    content: `白浆作为一种多组分复合材料，其性能优劣在很大程度上取决于原料的选择与配比。本文将从原料角度出发，系统解析白浆的组成体系。

## 一、天然矿物填料

天然矿物填料是白浆中用量最大的组分，通常占总质量的40%-70%。常用的天然矿物填料包括：

**碳酸钙（CaCO₃）**是最广泛使用的填料之一，分为重质碳酸钙和轻质碳酸钙两类。重质碳酸钙由天然石灰石机械粉碎而成，粒径分布较宽，成本低廉；轻质碳酸钙通过化学沉淀法制备，粒径均匀、白度高，更适用于高端白浆产品。

**滑石粉**具有良好的片状结构和润滑性，添加后可显著改善白浆的施工性能和表面光滑度。在建筑白浆中，滑石粉还能提升涂层的耐水性和抗裂性。

**高岭土**以其优异的悬浮稳定性和遮盖力著称。经煅烧处理的高岭土白度可达92%以上，是造纸白浆和高档建筑白浆的首选填料。

## 二、高分子粘结剂

粘结剂是白浆的"骨架"，决定了浆料的成膜性、附着力和耐久性。

**聚乙烯醇（PVA）**是最常用的水溶性粘结剂，具有优异的成膜性和粘结力。不同醇解度和聚合度的PVA可赋予白浆不同的流变特性。

**丙烯酸乳液**以其出色的耐水性、耐候性和柔韧性，在建筑外墙白浆中占据主导地位。纯丙乳液、苯丙乳液和硅丙乳液各有侧重，可根据实际需求选型。

**淀粉及其衍生物**在食品级白浆和造纸白浆中应用广泛。氧化淀粉、阳离子淀粉等改性产品在特定场景下表现优异。

## 三、功能性添加剂

功能性添加剂虽然用量不大（通常<5%），但对白浆的加工性能和使用效果影响显著。

**分散剂**确保各组分均匀分散，防止团聚沉淀。聚羧酸盐类和聚磷酸盐类分散剂各有适用体系。

**消泡剂**消除生产和施工过程中产生的气泡，保证浆料表面平整。有机硅类消泡剂效果持久，但需注意与体系的相容性。

**增稠剂**调节白浆的流变特性，赋予其适宜的触变性和抗流挂性。纤维素醚类和缔合型聚氨酯增稠剂是当前主流选择。

**防腐剂**防止白浆在储存过程中滋生微生物，延长产品保质期。卡松类防腐剂因其广谱高效而被广泛使用。`,
    category: "construction",
    categoryName: "建筑白浆",
    coverImage: "https://readdy.ai/api/search-image?query=Various%20white%20mineral%20powders%20and%20materials%20arranged%20on%20dark%20slate%20surface%2C%20professional%20studio%20lighting%2C%20warm%20neutral%20background%2C%20editorial%20photography%2C%20soft%20shadows%2C%20high%20detail%2C%20clean%20composition&width=1200&height=600&seq=baijiang-article-1&orientation=landscape",
    publishedAt: "2026-07-15",
    readTime: "8分钟",
    tags: ["原料", "矿物填料", "粘结剂", "添加剂"],
  },
  {
    id: "article-2",
    slug: "jianzhu-baijiang-shiyong-zhinan",
    title: "建筑白浆选购与使用完全指南",
    excerpt: "从施工环境、基层条件到性能指标，全面解析如何选择最适合您项目的建筑白浆产品，并掌握正确的施工方法。",
    content: `建筑白浆是建筑工程中用量最大的辅助材料之一，正确的选购和施工直接影响工程质量。本文将为您提供一份实用的选购与使用指南。

## 一、选购前的准备工作

**明确使用场景**：内墙和外墙对白浆的要求差异显著。外墙白浆需要具备优异的耐候性、抗紫外线和防水性能；内墙白浆则更注重环保性、施工便利性和表面细腻度。

**评估基层状况**：混凝土基层、砖墙基层、石膏板基层对白浆的粘结要求各不相同。疏松基层需要渗透性好的底涂型白浆，光滑基层则需要高粘结力的产品。

**计算用量**：白浆用量与施工面积、涂布厚度和产品密度相关。一般经验公式：用量(kg) = 面积(m²) × 厚度(mm) × 密度(kg/L)。

## 二、关键性能指标解读

**粘结强度**是衡量白浆与基层结合力度的核心指标。根据JG/T 298-2010标准，内墙白浆粘结强度应≥0.5MPa，外墙白浆应≥1.0MPa。

**抗压强度**反映白浆固化后承受压力的能力。地面找平用白浆对抗压强度要求较高，一般需≥15MPa。

**收缩率**直接影响白浆层是否会开裂。优质白浆的收缩率应控制在0.15%以下。

**开放时间**指白浆从搅拌到仍可施工的时间窗口。夏季高温时开放时间会缩短，需注意选择合适的产品。

## 三、施工要点

**基层处理**是关键的第一步。基层需坚实、干净、无油污和浮灰。过于干燥的基层应提前润湿，但不得有明水。

**搅拌**应使用电动搅拌器低速搅拌3-5分钟，静置2-3分钟后再搅拌1分钟。严禁随意加水改变产品配比。

**施工环境**温度宜在5°C-35°C之间，相对湿度不超过85%。极端天气条件下应暂停施工或采取防护措施。

**养护**是确保白浆性能充分发挥的重要环节。施工后24小时内应避免雨淋、暴晒和强烈通风。`,
    category: "construction",
    categoryName: "建筑白浆",
    coverImage: "https://readdy.ai/api/search-image?query=Professional%20worker%20applying%20white%20paste%20on%20wall%20with%20trowel%2C%20clean%20modern%20construction%20scene%2C%20warm%20natural%20lighting%2C%20editorial%20photography%2C%20high%20detail%2C%20soft%20shadows&width=1200&height=600&seq=baijiang-article-2&orientation=landscape",
    publishedAt: "2026-07-10",
    readTime: "10分钟",
    tags: ["选购指南", "施工", "性能指标", "建筑"],
  },
  {
    id: "article-3",
    slug: "zaozhi-baijiang-gongyi-chuangxin",
    title: "造纸白浆工艺创新：从传统到智能化",
    excerpt: "探索造纸白浆制备工艺的演进历程，了解现代智能化制浆技术如何提升纸张品质与生产效率，降低能耗与排放。",
    content: `造纸白浆的制备工艺经历了从手工到机械化再到智能化的演变过程。每一次技术革新都带来了纸张品质的飞跃和生产效率的显著提升。

## 一、传统制浆工艺回顾

传统造纸白浆制备主要依赖机械打浆和人工配浆。打浆工段通过物理机械力使纤维分丝帚化，增加纤维的比表面积和氢键结合能力。配浆工段则根据纸张品种要求，将不同比例的浆料、填料和助剂混合。

这种工艺依赖操作工人的经验判断，浆料质量波动较大，且能耗较高。一台传统的双盘磨浆机功率可达200-400kW，是造纸厂的主要能耗设备。

## 二、现代自动化制浆技术

**DCS集散控制系统**的应用实现了制浆过程的自动化监控。通过在线传感器实时检测浆料浓度、打浆度和pH值等关键参数，PLC控制器自动调节相关设备运行状态。

**锥形精浆机**的普及取代了部分传统盘磨机，其独特的锥形转子设计使得纤维处理更加温和均匀，在降低能耗的同时提高了浆料质量。

**自动配浆系统**通过精密计量泵和质量流量计，将多种浆料和助剂按配方精确配比，配浆精度可达±0.5%以内。

## 三、智能化发展趋势

**AI辅助决策**正逐步渗透到制浆工艺中。机器学习模型通过分析历史生产数据，能够预测最优工艺参数组合，实现质量与成本的最佳平衡。

**数字孪生技术**在新建造纸项目中展现出巨大潜力。通过建立制浆过程的虚拟仿真模型，工程师可以在不影响实际生产的情况下进行工艺优化和故障模拟。

**在线纤维形态分析仪**能够实时检测纤维长度、粗度和卷曲度等微观指标，为工艺调整提供数据支撑。`,
    category: "paper",
    categoryName: "造纸白浆",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20paper%20making%20industrial%20machine%20with%20white%20pulp%20flowing%2C%20clean%20factory%20environment%2C%20professional%20lighting%2C%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail%2C%20industrial%20aesthetic&width=1200&height=600&seq=baijiang-article-3&orientation=landscape",
    publishedAt: "2026-06-28",
    readTime: "9分钟",
    tags: ["工艺创新", "自动化", "智能化", "造纸"],
  },
  {
    id: "article-4",
    slug: "shipin-baijiang-anquan-biaozhun",
    title: "食品级白浆安全标准与质量认证体系",
    excerpt: "全面解读食品级白浆需要遵循的国内外安全标准，以及ISO 22000、HACCP等质量认证体系对产品的要求。",
    content: `食品级白浆直接或间接接触食品，其安全性关乎消费者健康。了解和遵循相关安全标准是每个从业者的基本责任。

## 一、国内标准体系

**GB 2760-2024《食品安全国家标准 食品添加剂使用标准》**是食品级白浆最核心的法规依据。该标准明确规定了允许使用的食品添加剂品种、使用范围和最大使用量。

**GB 9685-2016《食品安全国家标准 食品接触材料及制品用添加剂使用标准》**规定了与食品接触的白浆材料中可使用的添加剂及其限制条件。

**GB 4806系列标准**针对不同材质的食品接触材料制定了专项要求，白浆产品需根据其基材类型对应符合相应的标准条款。

## 二、国际标准对标

**FDA 21 CFR**（美国联邦法规）对食品接触材料有详细规定。出口美国市场的食品级白浆需满足FDA的相关条款，如21 CFR 175.300（树脂和聚合物涂层）等。

**EU No 10/2011**（欧盟食品接触塑料法规）是进入欧盟市场的准入门槛。该法规对迁移试验条件、特定迁移限量（SML）等有严格规定。

## 三、质量认证体系

**ISO 22000食品安全管理体系**是食品级白浆生产企业应建立的基础管理体系。该体系覆盖从原料采购到成品交付的全过程。

**HACCP危害分析与关键控制点**体系要求企业识别生产过程中的生物、化学和物理危害，并建立相应的控制措施。

**FSSC 22000**在ISO 22000基础上增加了更详细的前提方案要求，已获得GFSI（全球食品安全倡议）认可。

## 四、检测与合规

食品级白浆的常规检测项目包括：感官指标、理化指标（总迁移量、高锰酸钾消耗量、重金属等）、微生物指标和特定迁移量。企业应建立完善的批次追溯体系，确保每批产品可追溯到原料来源。`,
    category: "food",
    categoryName: "食品级白浆",
    coverImage: "https://readdy.ai/api/search-image?query=Food%20safety%20certification%20documents%20and%20white%20paste%20sample%20in%20laboratory%2C%20clean%20professional%20setting%2C%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail%2C%20sterile%20environment&width=1200&height=600&seq=baijiang-article-4&orientation=landscape",
    publishedAt: "2026-06-20",
    readTime: "11分钟",
    tags: ["食品安全", "认证标准", "质量管理", "法规"],
  },
  {
    id: "article-5",
    slug: "gongye-baijiang-dingzhi-fuwu",
    title: "工业白浆配方定制：满足特殊工艺需求",
    excerpt: "探讨工业白浆配方定制的流程与要点，如何根据不同行业的特殊需求调整粘度、固含量、干燥速度等关键参数。",
    content: `标准化白浆产品难以满足所有工业场景的个性化需求。配方定制服务因此成为工业白浆领域的重要增值服务。

## 一、配方定制的触发场景

**极端工况需求**：当标准产品无法满足耐温、耐腐蚀、耐辐射等特殊环境要求时，需要进行针对性配方调整。

**特殊基材匹配**：不同基材（金属、塑料、玻璃、陶瓷等）的表面特性差异显著，需要定制相应的粘结体系和表面处理方案。

**工艺匹配优化**：自动生产线对浆料的流变特性、开放时间和固化速度有严格要求，需通过配方调整实现最佳工艺匹配。

## 二、配方定制流程

**需求调研**是定制的起点。技术工程师需要与客户深入沟通，全面了解使用环境、基材类型、施工方式和性能期望。

**实验室小试**阶段，研发团队根据需求分析结果设计3-5个初始配方方案，通过模拟实验评估各方案的性能表现。

**中试验证**将筛选出的最优配方放大至中试规模，验证工艺可行性和批次稳定性。

**现场试用**是中试通过后的关键步骤。技术人员在客户实际生产线上进行试用验证，收集反馈并进行微调。

## 三、关键参数调控

**粘度调节**可通过改变增稠剂种类和用量实现。纤维素醚提供高剪切粘度，缔合型增稠剂提供低剪切粘度和流平性。

**固含量调整**直接影响产品的覆盖率和干燥速度。更高固含量意味着更少的挥发物和更快的成膜速度，但也会影响施工性。

**干燥速度控制**：通过调节溶剂体系和催干剂用量，可将表干时间控制在5分钟至2小时之间。`,
    category: "industrial",
    categoryName: "工业白浆",
    coverImage: "https://readdy.ai/api/search-image?query=Industrial%20laboratory%20with%20white%20paste%20samples%20and%20testing%20equipment%2C%20clean%20professional%20setting%2C%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail%2C%20scientific%20aesthetic&width=1200&height=600&seq=baijiang-article-5&orientation=landscape",
    publishedAt: "2026-06-12",
    readTime: "9分钟",
    tags: ["配方定制", "工业应用", "参数调控", "研发"],
  },
  {
    id: "article-6",
    slug: "baijiang-zhiliang-kongzhi",
    title: "白浆质量控制体系：从原料进厂到成品出厂",
    excerpt: "系统介绍白浆生产全过程的质量控制节点，包括原料检验、过程监控、成品检测及不合格品处理机制。",
    content: `质量是白浆产品的生命线。建立完善的质量控制体系，是确保产品批次稳定性和客户满意度的根本保障。

## 一、原料进厂检验

**供应商准入管理**是质量控制的第一道关口。主要原料供应商需通过现场审核，评估其生产条件、质量管理体系和供货能力。

**进厂检验项目**根据原料类型设定。填料类原料重点检测白度、细度、水分和杂质含量；粘结剂类原料检测固含量、粘度、pH值和最低成膜温度；添加剂类原料根据功能特性设定专项检测。

**让步接收机制**：当原料某项指标轻微偏离标准但不影响最终产品性能时，经技术部门评估后可让步接收，但需做好标识和跟踪。

## 二、生产过程监控

**在线检测**是现代白浆生产线的标配。通过在线粘度计、pH计和密度计，操作人员可实时掌握浆料状态变化。

**关键控制点（CCP）**的设定基于HACCP原理。每个CCP需明确控制指标、检测频率、纠偏措施和责任人。

**中控样品留样**制度确保每批次生产有据可查。留样保存期限一般不低于产品保质期。

## 三、成品检测与放行

**出厂检验**项目包括外观、粘度、固含量、细度、pH值、密度等常规指标，以及产品标准规定的型式检验项目。

**批次追溯系统**通过唯一的批次编号，可追溯到每个成品批次对应的原料批次、生产班组和设备运行参数。

**不合格品处理**严格执行隔离、标识、评审和处置流程，防止不合格品非预期使用。`,
    category: "industrial",
    categoryName: "工业白浆",
    coverImage: "https://readdy.ai/api/search-image?query=Quality%20control%20laboratory%20testing%20white%20paste%20samples%2C%20clean%20professional%20setting%2C%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail%2C%20precision%20instruments&width=1200&height=600&seq=baijiang-article-6&orientation=landscape",
    publishedAt: "2026-05-30",
    readTime: "8分钟",
    tags: ["质量控制", "管理体系", "检测", "生产"],
  },
  {
    id: "article-7",
    slug: "huanbao-baijiang-fazhan-qushi",
    title: "环保型白浆的发展趋势与市场前景",
    excerpt: "随着环保法规日益严格，低VOC、水性化、生物基白浆成为行业热点。本文分析环保型白浆的技术路线与市场机遇。",
    content: `在全球碳中和目标和绿色消费理念的双重驱动下，环保型白浆正成为行业转型升级的主要方向。

## 一、政策与市场驱动

**VOC排放管控**日趋严格。中国《"十四五"挥发性有机物综合治理方案》明确提出到2025年，VOC排放总量较2020年下降10%以上。涂料、胶黏剂等相关行业首当其冲。

**绿色建筑认证**推动环保建材需求增长。LEED、BREEAM和中国绿色建筑评价标准均对室内装饰材料的VOC含量有严格要求。

**消费者健康意识**提升使得"环保""零甲醛""无异味"成为选购关键词，倒逼企业升级产品。

## 二、技术路线

**水性化**是最成熟的环保化路径。以水替代有机溶剂作为分散介质，可将VOC含量降至接近零。水性白浆的技术难点在于干燥速度慢和低温成膜性差，需通过配方优化解决。

**高固含/无溶剂**体系通过提高固含量减少挥发性组分。UV固化白浆是这一路线的典型代表，固化过程几乎零VOC排放。

**生物基材料替代**是前沿方向。以植物油、淀粉、蛋白质等可再生资源替代石油基原料，既减少碳足迹，又提升产品的可持续形象。

## 三、市场前景

据行业研究机构预测，全球环保型白浆市场规模将以年均8%-12%的速度增长，到2030年有望突破500亿元人民币。亚太地区尤其是中国市场，将是增长的主要引擎。`,
    category: "paper",
    categoryName: "造纸白浆",
    coverImage: "https://readdy.ai/api/search-image?query=Eco%20friendly%20white%20paste%20with%20green%20leaves%20and%20natural%20elements%2C%20clean%20minimalist%20composition%2C%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail%2C%20sustainable%20concept&width=1200&height=600&seq=baijiang-article-7&orientation=landscape",
    publishedAt: "2026-05-18",
    readTime: "7分钟",
    tags: ["环保", "低VOC", "水性化", "市场趋势"],
  },
  {
    id: "article-8",
    slug: "baijiang-shiyong-changjian-wenti",
    title: "白浆使用常见问题与解决方案",
    excerpt: "汇总白浆施工和使用过程中的常见问题，包括开裂、脱落、起泡、变色等现象的原因分析与针对性解决方案。",
    content: `即使使用优质白浆产品，施工不当或环境因素仍可能导致各种问题。本文汇总了最常见的白浆使用问题及其解决方案。

## 一、开裂问题

**现象**：白浆层出现龟裂状或直线状裂纹，严重时呈网状分布。

**原因分析**：(1) 单次涂布过厚，表层干燥收缩快于内部；(2) 基层吸水过快，浆料失水严重；(3) 环境温度过高或风速过大；(4) 产品收缩率偏大。

**解决方案**：(1) 控制单次涂布厚度，采用"薄涂多遍"；(2) 施工前充分润湿基层；(3) 避免在极端天气施工；(4) 选择低收缩配方产品。

## 二、脱落问题

**现象**：白浆层与基层分离，呈片状或块状脱落。

**原因分析**：(1) 基层处理不当，存在浮灰、油污等隔离层；(2) 基层过于光滑，机械咬合力不足；(3) 界面剂选择或使用不当；(4) 基层含水率过高。

**解决方案**：(1) 彻底清洁基层，必要时打磨处理；(2) 光滑基层使用界面剂增加粗糙度；(3) 确保基层含水率达标后再施工。

## 三、起泡问题

**现象**：白浆表面出现大小不一的气泡或针孔。

**原因分析**：(1) 搅拌速度过快引入大量空气；(2) 基层孔隙率大，施工后气体逸出；(3) 消泡剂不足或失效；(4) 一次性涂布过厚。

**解决方案**：(1) 控制搅拌速度和时间；(2) 多孔基层先做封闭处理；(3) 补充高效消泡剂；(4) 控制单次涂布厚度。`,
    category: "construction",
    categoryName: "建筑白浆",
    coverImage: "https://readdy.ai/api/search-image?query=Wall%20surface%20with%20white%20paste%20showing%20repair%20process%2C%20clean%20minimalist%20scene%2C%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail%2C%20practical%20demonstration&width=1200&height=600&seq=baijiang-article-8&orientation=landscape",
    publishedAt: "2026-05-05",
    readTime: "9分钟",
    tags: ["问题解决", "施工", "开裂", "脱落"],
  },
];

export const faqs = [
  {
    question: "白浆的主要成分是什么？",
    answer: "白浆主要由天然矿物填料（如碳酸钙、滑石粉、高岭土）、高分子粘结剂（如聚乙烯醇、丙烯酸乳液）和功能性添加剂（分散剂、消泡剂、增稠剂等）三大部分组成，各组分比例根据具体用途调整。",
  },
  {
    question: "如何选择适合自己需求的白浆产品？",
    answer: "选择白浆需综合考虑使用场景（内墙/外墙/地面）、基层类型（混凝土/砖墙/石膏板）、施工条件和性能需求（粘结力/耐水性/环保等级）。建议先明确应用场景后，再对比各产品的性能参数和适用条件。",
  },
  {
    question: "白浆的保质期一般是多久？",
    answer: "大多数白浆产品在密封、阴凉（5°C-35°C）、干燥条件下储存，保质期为6-12个月。食品级白浆的保质期通常为12个月，工业白浆根据配方不同有所差异。开盖后应尽快使用完毕。",
  },
  {
    question: "白浆施工对环境温度有要求吗？",
    answer: "是的，白浆施工的推荐环境温度为5°C-35°C，相对湿度不超过85%。温度过低会导致干燥缓慢甚至无法正常成膜，温度过高则开放时间过短，影响施工操作。极端天气建议暂停施工。",
  },
  {
    question: "食品级白浆与工业白浆有什么区别？",
    answer: "食品级白浆严格按照食品安全国家标准生产，对原料选择、重金属含量、微生物指标等有严格限制，并需通过ISO 22000、HACCP等认证。工业白浆则更注重物理性能指标，如粘结强度、耐温性、耐腐蚀性等。两者不可混用。",
  },
  {
    question: "白浆是否可以加水稀释？",
    answer: "一般不建议自行加水稀释白浆产品。白浆的配方经过精密设计，随意加水会破坏各组分比例，导致粘结力下降、开裂风险增加等问题。如需调整粘度，应使用厂家推荐的专用稀释剂或咨询技术支持。",
  },
];

export const siteInfo = {
  name: "白浆百科",
  fullName: "白浆百科 - 传统工艺与现代应用全解析",
  description: "白浆是一种广泛应用于建筑、造纸、食品及工业领域的白色浆状物料。白浆百科深入介绍白浆的原料组成、制备工艺、性能特点及选购指南，帮助您全面了解白浆的用途与价值。",
  keywords: "白浆,白浆制备工艺,白浆原料组成,建筑白浆用途,工业白浆选购,白浆性能参数,白浆应用场景",
  url: "https://www.baijiang-baike.com",
};